import { useEffect, useState } from "react";
import { getAxiosWithToken, putAxiosWithToken } from "../../service/axios_service";
import { chapterEndPoint } from "../../service/api_endpoints";
import { useParams } from "react-router-dom";
import { setIsLoading } from "../../redux/layout_slice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../session/Loading";
import GroupsList from "../create_chapter/groups_list";
import { Dialog, DialogPanel, DialogTitle, Description } from '@headlessui/react';
import toast from 'react-hot-toast';

export default function ViewChapter() {

    const dispatch = useDispatch();
    const { id } = useParams();

    const { isLoading } = useSelector((state) => state.layoutSlice);

    const [chapterDetails, setChapterDetails] = useState({});
    const [groupsList, setGroupList] = useState([]);
    const [contactsList, setContactList] = useState([]);

    // Add More Groups state
    const [isAddGroupModalOpen, setIsAddGroupModalOpen] = useState(false);
    const [selectedNewGroupList, setSelectedNewGroupList] = useState([]);
    const [isSubmittingNewGroups, setIsSubmittingNewGroups] = useState(false);

    useEffect(() => {
        getChapterDetails()
    }, [])

    const getChapterDetails = async () => {
        let response = await getAxiosWithToken({
            url: `${chapterEndPoint}?id=${id}`
        })

        if (response != null) {
            setChapterDetails(response.data)
            setGroupList(response.data?.group_details)
            setContactList(response.data?.contact_details)
            dispatch(setIsLoading(false))
        }
    }

    const handleAddGroupsSubmit = async () => {
        if (!selectedNewGroupList || selectedNewGroupList.length === 0) {
            toast.info("Please select at least 1 group to add!");
            return;
        }

        setIsSubmittingNewGroups(true);

        const tempGroupIds = selectedNewGroupList.map(item => item.id);

        const body = {
            id: id,
            add_group: tempGroupIds
        };

        const response = await putAxiosWithToken({
            url: chapterEndPoint,
            body: body
        });

        setIsSubmittingNewGroups(false);

        if (response != null) {
            toast.success(response.message || "Groups added successfully!");
            setIsAddGroupModalOpen(false);
            setSelectedNewGroupList([]);
            getChapterDetails();
        }
    }

    return (
        isLoading ? <div className='h-[calc(100vh-200px)] w-full flex items-center justify-center'><Loading /></div> :
        <div>
            <div className="flex items-center justify-between mb-[25px]">
                <p className="text-2xl font-bold">: {chapterDetails.chapter_name}</p>
                <button
                    onClick={() => {
                        setSelectedNewGroupList([]);
                        setIsAddGroupModalOpen(true);
                    }}
                    className="bg-primary text-white font-semibold text-sm px-[16px] py-[8px] rounded hover:bg-primary-dark transition flex items-center gap-2"
                >
                    + Add More Groups
                </button>
            </div>

            <div className="flex gap-1">
                <div className="w-1/2 h-[calc(100vh-200px)] overflow-scroll">
                    <table className="w-full">
                        <thead className="bg-light-gray text-white">
                            <tr>
                                <th className="p-[10px] text-left">S No</th>
                                <th className="p-[10px] text-left">Fav Group Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                groupsList?.map((item, index) => (
                                    <tr key={index} className={`${index % 2 != 0 ? "bg-input-gray" : ""} border-b`}>
                                        <td className="p-[10px]">{index + 1}</td>
                                        <td className="p-[10px]">{item.group_details__group_name}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <div className="w-1/2 h-[calc(100vh-200px)] overflow-scroll">
                    <table className="w-full">
                        <thead className="bg-light-gray text-white">
                            <tr>
                                <th className="p-[10px] text-left">S No</th>
                                <th className="p-[10px] text-left">Contact Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                contactsList?.map((item, index) => (
                                    <tr key={index} className={`${index % 2 != 0 ? "bg-input-gray" : ""} border-b`}>
                                        <td className="p-[10px]">{index + 1}</td>
                                        <td className="p-[10px]">{item.contact_details__contact_name}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Add More Groups Modal Dialog */}
            <Dialog open={isAddGroupModalOpen} onClose={() => setIsAddGroupModalOpen(false)} className="relative z-50">
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
                    <DialogPanel className="w-full max-w-6xl max-h-[92vh] overflow-y-auto border bg-white p-6 rounded-lg shadow-xl">
                        <div className="flex items-center justify-between border-b pb-3 mb-4">
                            <DialogTitle className="font-bold text-xl text-black">
                                Add Groups to "{chapterDetails.chapter_name}"
                            </DialogTitle>
                            <button
                                onClick={() => setIsAddGroupModalOpen(false)}
                                className="text-gray-500 hover:text-black font-bold text-lg px-2"
                            >
                                ✕
                            </button>
                        </div>

                        <Description className="text-sm text-gray-600 mb-4">
                            Search available WhatsApp groups on the left, view existing groups on the right (Read Only), and append new groups.
                        </Description>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                            {/* Left Side: Groups Search & List */}
                            <div className="w-full border p-3 rounded bg-gray-50/50">
                                <p className="font-bold text-base mb-2 text-black">Available Groups to Select</p>
                                <GroupsList
                                    selectedGroupList={selectedNewGroupList}
                                    setSelectedGroupList={setSelectedNewGroupList}
                                />
                            </div>

                            {/* Right Side: Existing Groups (Read Only) & Newly Selected Groups */}
                            <div className="w-full space-y-4">
                                {/* 1. Existing Groups in Fav Group (Read-Only) */}
                                <div className="border p-3 rounded bg-blue-50/30">
                                    <div className="flex items-center justify-between mb-2">
                                        <p className="font-bold text-base text-black flex items-center gap-2">
                                            Existing Groups in "{chapterDetails.chapter_name}" ({groupsList?.length || 0})
                                        </p>
                                        <span className="text-xs bg-blue-100 text-blue-800 font-semibold px-2 py-0.5 rounded border border-blue-200">
                                            Read Only
                                        </span>
                                    </div>

                                    <div className="max-h-[190px] overflow-y-auto border rounded bg-white">
                                        <table className="w-full text-sm">
                                            <thead className="bg-light-gray text-white sticky top-0">
                                                <tr>
                                                    <th className="p-[8px] text-left">S No</th>
                                                    <th className="p-[8px] text-left">Group Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!groupsList || groupsList.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={2} className="p-3 text-center text-gray-500 italic">
                                                            No existing groups found in this Fav Group.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    groupsList.map((item, index) => (
                                                        <tr key={index} className={`${index % 2 !== 0 ? "bg-input-gray" : ""} border-b`}>
                                                            <td className="p-[8px] text-gray-600">{index + 1}</td>
                                                            <td className="p-[8px] font-medium text-gray-800">
                                                                {item.group_details__group_name}
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* 2. Newly Selected Groups to Add */}
                                <div className="border p-3 rounded bg-green-50/30">
                                    <div className="flex items-center justify-between mb-2">
                                        <p className="font-bold text-base text-black">
                                            Newly Selected Groups to Add ({selectedNewGroupList.length})
                                        </p>
                                    </div>

                                    <div className="max-h-[190px] overflow-y-auto border rounded bg-white">
                                        <table className="w-full text-sm">
                                            <thead className="bg-light-gray text-white sticky top-0">
                                                <tr>
                                                    <th className="p-[8px] text-left">S No</th>
                                                    <th className="p-[8px] text-left">Group Name</th>
                                                    <th className="p-[8px] text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedNewGroupList.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={3} className="p-3 text-center text-gray-500 italic">
                                                            No new groups selected yet. Click groups on the left to add.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    selectedNewGroupList.map((item, index) => (
                                                        <tr key={index} className={`${index % 2 !== 0 ? "bg-input-gray" : ""} border-b`}>
                                                            <td className="p-[8px]">{index + 1}</td>
                                                            <td className="p-[8px] font-medium text-gray-800">{item.group_name}</td>
                                                            <td className="p-[8px] text-center">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setSelectedNewGroupList(
                                                                            selectedNewGroupList.filter(g => g.id !== item.id)
                                                                        );
                                                                    }}
                                                                    className="text-red-600 hover:text-red-800 text-xs font-bold px-2 py-1 bg-red-50 hover:bg-red-100 rounded"
                                                                >
                                                                    Remove
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-end gap-3 mt-6 border-t pt-4">
                            <button
                                type="button"
                                disabled={isSubmittingNewGroups}
                                onClick={() => setIsAddGroupModalOpen(false)}
                                className="bg-light-gray px-4 py-2 text-white rounded font-medium text-sm hover:opacity-90"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                disabled={isSubmittingNewGroups}
                                onClick={handleAddGroupsSubmit}
                                className="bg-primary px-5 py-2 text-white rounded font-semibold text-sm hover:bg-primary-dark transition"
                            >
                                {isSubmittingNewGroups ? "Saving Groups..." : `Save Groups (${selectedNewGroupList.length})`}
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </div>
    );
}